
import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';
import ListCardFooterSkeleton from './ListCardFooterSkeleton';
import { boxShadow } from 'constants/utilsStyles';
import classNames from 'classnames';

const Wrapper = styled.div`
  &.tileView {
    padding: 10px 10px 10px 20px;
    flex-direction: row;
    align-items: center;
    .image-skeleton {
      height: 70px !important;
      width: 80px !important;
      min-width: 80px !important;
      border-radius: 8px !important;
    }
    .inner-skeleton {
      width: calc(100% - 85px);
      display: flex;
      flex-direction: row;
      .textual-skeleton {
        width: calc(100% - 200px);
        .activity-skeleton {
          margin-left: 0px;
        }
        .skeleton-box-global { 
          width: 40% !important;
          min-width: 40% !important;
          border-radius: 8px !important;
          margin: 0px 5px 5px 0px !important;
          svg {
            width: 50px;
          }
        }
      }
      .list-card-footer-skeleton {
        .skeleton-box-global {
          margin-left: 10px;
        }
      }
    }
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${boxShadow};
  border-radius: 13px;
  margin: 0 10px;
  .inner-skeleton {
    padding: 10px;
    .textual-skeleton {
      .activity-skeleton {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        margin-left: 7px;
      }
    }
  }
`;
type Props = {
  listView?: boolean,
} & typeof defaultProps;

const defaultProps = {
  listView: false,
};
const ListCardSkeleton = function ListCardSkeleton(props: Props) {
  const { listView } = props;
  console.log('list', listView);

  return (
    <Wrapper className={classNames('list-card-skeleton', { tileView: listView })}>
      <SkeletonCustom
        height='180px'
        diameter='13px 13px 0 0'
        className='image-skeleton'
        margin='0px'
        logo
      />
      <div className='inner-skeleton'>
        <div className='textual-skeleton'>
          <SkeletonCustom
            height='20px'
            diameter='23px'
            margin='0px 5px 5px 5px'
          />
          <div className='activity-skeleton'>
            <SkeletonCustom
              height='10px'
              width='30%'
              diameter='23px'
              margin='0px'
            />
            <SkeletonCustom
              height='10px'
              width='calc(70% - 10px)'
              diameter='23px'
              margin='0 0 0 10px'
              marginSm='0 0 0 10px'
            />
          </div>
        </div>
        <ListCardFooterSkeleton />
      </div>
    </Wrapper>
  );
};
ListCardSkeleton.defaultProps = defaultProps;
export default ListCardSkeleton;